import React from "react";
import { NavLink } from "react-router-dom";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import DoubleArrowRoundedIcon from "@material-ui/icons/DoubleArrowRounded";
import * as Dati from "../../../../Dati";
import { Trad } from "../../../../components";
import useInfoSection from "../../../hooks/InfoSection";

const useStyles = makeStyles(({ spacing }: Theme) => ({
    title: {
        paddingBottom: 0
    },
    link: {
        marginTop: spacing(3)
    },
    valueItem: {
        textAlign: "right",
        marginRight: spacing(3)
    }
}));

interface IInfoSectionProps {
    DataUrl: string;
    Title: string;
    LinkUrl?: string;
}

export const _InfoSection: React.FC<IInfoSectionProps> = ({ DataUrl, LinkUrl, Title }) => {
    const classes = useStyles();
    const Data = useInfoSection(DataUrl);

    return (
        <Card>
            <CardHeader title={Trad.Trad(Title)} titleTypographyProps={{ variant: "h6" }} className={classes.title} />
            <CardContent>
                <Grid container spacing={1} direction={Data.length > 3 ? "row" : "column"}>
                    {Data.map((item: Dati.CDatiContesto, index: number) => (
                        <Grid item xs={12} md={5} container spacing={1} key={index}>
                            <Grid item xs={7}>
                                <Typography variant="subtitle2">{Trad.Trad(item.Etichetta)}</Typography>
                            </Grid>
                            <Grid item xs={4} className={classes.valueItem}>
                                {item.ParametroTrad ? Trad.TradParam(item.ParametroTrad, [item.Valore]) : item.Valore}
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
                {LinkUrl && (
                    <Button component={"a"} variant="outlined" color="secondary" href={LinkUrl} endIcon={<DoubleArrowRoundedIcon />} className={classes.link} size="small">
                        {Trad.Trad("Visualizza")}
                    </Button>
                )}
            </CardContent>
        </Card>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/InfoSection/InfoSection.tsx